export default {
    downtimeUrl: "https://id.kodland.tech",
    timer: {
        minutes: 5,
        price: 93500,
        currency: "Rp",
      },
    startPage: {
      image: "/welcome/quiz_indo_coding_2.jpeg",
      title: "Selesaikan survei 2 menit dan dapatkan undangan kelas pemrograman GRATIS",
      subtitle:
        "Di kelas ini, kami akan membuat proyek bersama anak anda, dan membuktikan waktu penggunaan komputer anak anda lebih bermanfaat.",
      button: "Mulai 🚀",
    },
    successPage: {
      title: "Pilih tanggal dan waktu untuk mendapatkan pelajaran GRATIS 🚀",
      subtitle: "Klik tombol “📆 Pesan” dan dapatkan pelajarannya.",
      button: "📆 Pesan",
    },
    quizRotateBySteps: {
      1: {
        question: "Apakah anak Anda mengikuti kegiatan ekstrakurikuler di luar pembelajaran sekolah?",
        answers: [
          "📚 Kelas yang membantu untuk meningkatkan nilai pembelajara",
          "⛹️ Ya. Kegiatan olahraga",
          "🎨 Ya. Kelas seni",
          "💻 Ya. Kelas koding dan ilmu komputer",
          "🏕️ Ya. Pramuka",
          "✖️ Tidak. Anak tidak memiliki waktu untuk itu",
        ],
      },
      2: {
        question: "Apa mata pelajaran kesukaan anak Anda?",
        answers: [
          "🔬 Sains",
          "🎨 Seni dan desain",
          "💻 Ilmu komputer",
          "🏛️ Ilmu budaya",
          "📐 Matematika",
          "💬 Ilmu Bahasa",
          "🤩 Semua yang di atas",
        ],
      },
      3: {
        question:
          "Apakah anda ingin waktu yang dihabiskan anak anda di depan komputer menjadi lebih produktif?",
        answers: ["😍 Ya!", "🙂 Tidak. Ini hanya untuk bersenang-senang dan tidak masalah."],
      },
    },
  };
  